const API_NAME = process.env.REACT_APP_API_NAME
  ? `/${process.env.REACT_APP_API_NAME}`
  : "";

const baseurl = `${process.env.REACT_APP_PROTOCOL}://${process.env.REACT_APP_IP}${API_NAME}`;

export const apiBaseurl = baseurl + "/api";
export const clientBaseurl = baseurl + "/client";
